import template from './adpIconButton.html';
import controller from './adpIconButton.controller';
import './adpIconButton.less';

let adpIconButtonComponent = {
  restrict: 'E',
  bindings: {
    isGrey: "<",
    isBlue: "<",
    hasAttachment: "<",
    icon: "@",
    label: "@",
  },
  template,
  controller
};

export default adpIconButtonComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpIconButton/adpIconButton.component.js